import {
  JOB_SEARCH_LINK_TEXT,
  JOB_TREND_LINK_TEXT,
  OCCUPATION_LINK_TEXT,
} from '@doda/common/src/constants/seo/jobContentCommonConstants';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import {
  measureClickJobSearchListLink,
  measureClickJobTrendLink,
  measureClickOccupationLink,
} from '@doda/common/src/logics/JobContent/JobRanking/analytics';

// 求人ランキングページ_キャリーID
export const JOB_RANKING_CARRY_ID = '5100004903';

// ページリード文
export const LEAD_TEXT = {
  MAIN: 'dodaに掲載している「%s」の求人情報の中で、応募数が多い求人をランキング形式でご紹介します。',
  NOTICE: '※応募数が同数の場合は、新着順に表示しています。',
};

// ランキング概要
export const NOTICE_TEXT = {
  TEXT_FIRST:
    '※求人応募完了数の多い順にランキングしています（非公開求人は除く）。',
  TEXT_SECOND: '※集計対象期間：%s～%s',
  TEXT_THIRD:
    '※応募や採用の状況により、掲載予定期間の終了前に掲載を終了することがあります。その場合は当サイトから応募はできませんので、あらかじめご了承ください。',
};

// 計測用パラメータ
export const PAGE_NAME_PC = '人気求人ランキング';
export const PAGE_NAME_SP = 'SP_人気求人ランキング';
export const CHANNEL = '求人コンテンツ';
export const JOB_RANKING = 'JobRanking';
export const MEMBER_REGIST = '_memberRegist_';
export const LOGIN = '_login_';
export const INTRO = '_intro_';
export const TOP = 'top';
export const BOTTOM = 'bottom';
export const JOB_CARD_CLICK = '_KyuujinCassette_click';

// カテゴリ別の人気求人ランキングタイトル名
export const OTHER_JOB_RANKING_TITLE = 'カテゴリ別の人気求人ランキング';

// 人気求人ランキングページの表示求人上限
export const JOB_RANKING_API_LIMIT = 25;

export const OTHER_PAGE_LINK_ITEMS = [
  {
    title: JOB_SEARCH_LINK_TEXT.TITLE,
    description: JOB_SEARCH_LINK_TEXT.DESCRIPTION,
    siteUrl: DODA_SITE_URL.jobSearchList,
    imagePath: JOB_SEARCH_LINK_TEXT.IMAGE_PATH,
    preBtn: true,
    handleMeasurement: measureClickJobSearchListLink,
  },
  {
    title: JOB_TREND_LINK_TEXT.TITLE,
    description: JOB_TREND_LINK_TEXT.DESCRIPTION,
    siteUrl: DODA_SITE_URL.jobTrend,
    imagePath: JOB_TREND_LINK_TEXT.IMAGE_PATH,
    preBtn: false,
    handleMeasurement: measureClickJobTrendLink,
  },
  {
    title: OCCUPATION_LINK_TEXT.TITLE,
    description: OCCUPATION_LINK_TEXT.DESCRIPTION,
    siteUrl: DODA_SITE_URL.occupation,
    imagePath: OCCUPATION_LINK_TEXT.IMAGE_PATH,
    preBtn: false,
    handleMeasurement: measureClickOccupationLink,
  },
];
